/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".loader-hidden[_ngcontent-%COMP%]{visibility:hidden}.loader-overlay[_ngcontent-%COMP%]{position:absolute;top:0;left:0;opacity:1;z-index:500000;width:100%;height:100%;background-color:rgba(209,203,203,.5);color:#565555;text-align:center;line-height:200px}[_nghost-%COMP%]     path{stroke:#2196f3!important}#loader[_ngcontent-%COMP%]{position:absolute;top:50%;font-size:40px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/shared/templates/template1/themes/default/CSS/app-loader.component.less.shim.ngstyle.js.pre-build-optimizer.js